import * as React from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '../components/Typography';

const item = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  px: 5,
};

function ProductValues() {
  return (
    <Box
      id='values'
      component="section"
      sx={{ display: 'flex', overflow: 'hidden', bgcolor: 'secondary.light' }}
    >
      <Container sx={{ mt: {xs: 5, sm: 5}, mb: 18, display: 'flex', position: 'relative' }}>
        <Box
          sx={{ pointerEvents: 'none', position: 'absolute', top: -180 }}
        />
        <Grid container spacing={5}>
          <Grid item xs={12} md={4}>
            <Box sx={item}>
              <Typography variant="h4" sx={{ my: 5 }}>
              Unleash New Potentials
              </Typography>
              <Typography variant="h5">
              Dive deep into cloud innovation with personalized consulting that transcends traditional boundaries. Whether it's harnessing the power of AWS for unparalleled infrastructure agility or crafting bespoke software solutions, our approach ensures that your enterprise thrives in the digital era. Every consultation with us is a step towards redefining what's possible for your business.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box sx={item}>
              <Typography variant="h4" sx={{ my: 5 }}>
              Preferred Partner 
              </Typography>
              <Typography variant="h5">
              As members of MK Technologies, you gain exclusive access to our deep industry insights and preferential rates. Our partnership model is designed to empower your business with cutting-edge cloud solutions at unmatched value. Let's build the future of your IT landscape together, with strategic investments that pay dividends in operational excellence.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box sx={item}>
              <Typography variant="h4" sx={{ my: 5 }}>
              Tailored Solutions
              </Typography>
              <Typography variant="h5">
              MK Technologies delivers a comprehensive suite of cloud services tailored to your business needs. We specialize in cloud-native software engineering, serverless architectures, and scalable containerized deployments, ensuring robust and efficient solutions. Our expertise also includes advanced ETL processes, disaster recovery planning, and virtual desktop infrastructure, all designed to enhance your business's agility, security, and resilience.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default ProductValues;
